export default (data, condition, state = [[], []]) => {
    data.forEach(value => {
        if (condition(value)) {
            state[0].push(value);
        } else {
            state[1].push(value);
        }
    });
    return state;
};
